/* eslint-disable indent */
import { OutboxMessageCriteria } from '@src/main/modules/messages/domain/message/outbox/outbox-message-criteria.interface';
import { OutboxMessage } from '@src/main/modules/messages/domain/message/outbox/outbox-message.interface';
import { OutboxMessageRepository } from '@src/main/modules/messages/domain/message/outbox/outbox-message.repository';
import { useOutboxMessages } from '@src/main/modules/messages/ui/mailbox/hooks/mailbox/useOutboxMessages';
import { FormattedOutboxMessage } from '@src/main/modules/messages/ui/mailbox/model/formated-message.model';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';
import { useMemo } from 'react';

export const useFormattedOutboxMessages = (
  repository: OutboxMessageRepository,
  criteria: OutboxMessageCriteria,
) => {
  const { data, isLoading, error } = useOutboxMessages(repository, criteria);

  const formattedData: PageResponse<FormattedOutboxMessage> | undefined = useMemo(() => {
    if (!data) return undefined;

    const flatItems = data.items.flat();

    const formattedItems = flatItems.map((i: OutboxMessage) => ({
      id: i.notificationId,
      ...i,
      sendBy: i.sendByName ? `${i.sendByName} (${i.sendBy})` : i.sendBy,
      recipients: i.recipients.map((r) =>
        r.recipientName && r.recipient !== r.recipientName
          ? `${r.recipientName} (${r.recipient})`
          : r.recipient,
      ),
      respondedFrom: i.respondedFrom
        ? {
            ...i.respondedFrom,
            recipients: i.respondedFrom.recipients.map((r) =>
              r.recipientName && r.recipient !== r.recipientName
                ? `${r.recipientName} (${r.recipient})`
                : r.recipient,
            ),
          }
        : undefined,
    }));

    return {
      ...data,
      items: formattedItems,
    };
  }, [data]);

  return {
    data: formattedData,
    messages: formattedData?.items ?? [],
    total: formattedData?.total ?? 0,
    pageNumber: formattedData?.pageNumber ?? 0,
    pageSize: formattedData?.pageSize ?? 0,
    first: formattedData?.first ?? true,
    last: formattedData?.last ?? false,
    isLoading,
    error,
  };
};
